
import React from "react";
import {
    Box,
    Image,
    Text,
    CheckBox
} from "grommet";

const CheckBoxCards = ({ cards }) => {

    return (
        <Box justify="center"
            direction="row" gap="small"
        >
            {cards.map((card, index) => (
                <Box key={index} gap="small" justify="center" align="center">
                    <Box width={card.size || 'medium'}>
                        <Image style={{cursor: 'pointer'}} src={card.photo} onClick={card.onChange}/>
                    </Box>
                    <Text style={{fontWeight: card.checked ? 'bold' : 'normal'}}>{card.title}</Text>
                    <CheckBox checked={card.checked} onChange={card.onChange} />
                </Box>
            ))}

        </Box>
    )
}

export default CheckBoxCards;